/**
 * @Author: Zero
 * @Date: 2025-07-15 09:37:49
 * @Explain: 分层类型
 */
// type
import type { ConditionsListIF } from '@/api/segmentsManage/data';
import type { SelectItemType } from '@/components/tdesign/data.d';
import type { TooltipProps } from 'tdesign-react';

// 处理什么类型的数据
export enum HandleDataType {
  SUBMIT = 'submit',
  DETAILS = 'details',
}

/** 分层类型 */
export enum SegmentTypeEnum {
  /** 默认 */
  DEFAULT = 'default',
  /** 内置分层 */
  BUILT_IN_SCHEME = 'builtInScheme',
}

export enum ExtendDataKeyEnum {
  JOIN_TIME = 'joinTime',
  JOIN_CHANNEL = 'joinChannel',
}

/** 来源 - 扩展内容 */
export interface ExtendDataItemIF {
  /** 1：早于 2：晚于 3：timeSlot 4：距离现在 */
  dateOption?: number;
  value?: any;
  startTime?: any;
  endTime?: any;
  timezone?: string;
  errorArr?: any[];
  errorMsg?: any;
  /** 范围、等于、不等于 */
  subOperator?: string;
  /** 最小值 */
  leftValue?: string;
  /** 最大值 */
  rightValue?: string;
}

/** 联系人参与度 - 单选 */
export enum ContactEngagementRadioEnum {
  TIME_RANGE = 1,
  CAMPAIGNS = 2,
}
/** 联系人参与度 - 条件 */
export enum ContactEngagementFilterEnum {
  CLICKED = 'clicked',
  OPENED = 'opened',
  SEND = 'sent',

  NOT_CLICKED = 'notClicked',
  NOT_OPENED = 'notOpened',
  NOT_SEND = 'notSent',
}

/** WhatsApp活动 - 条件 */
export enum WhatsAppActivityFilterEnum {
  /** WhatsApp活动点击 */
  CLICKED = 'whatsappClicked',
  /** WhatsApp活动未发送 */
  NOT_SENT = 'whatsappNotSent',
  /** WhatsApp活动未读 */
  NOT_READ = 'whatsappNotRead',
  /** WhatsApp活动已发送 */
  SENT = 'whatsappSent',
  /** WhatsApp活动已读 */
  READ = 'whatsappRead',
  /** WhatsApp活动已回复 */
  REPLIED = 'whatsappReplied',
}

/** 联系人参与度说明文案 - 条件   **/
export enum ContactEngagementDescriptionEnum {
  NOT_CLICKED_CAMPAIGNS = 'notClicked-2',
  NOT_CLICKED_RANGE = 'notClicked-1',
  NOT_OPENED_CAMPAIGNS = 'notOpened-2',
  NOT_OPENED_RANGE = 'notOpened-1',
  NOT_SEND_CAMPAIGNS = 'notSent-2',
  NOT_SEND_RANGE = 'notSent-1',
  SEND_RANGE = 'sent-1',
  SEND_CAMPAIGNS = 'sent-2',
  WHATSAPP_NOT_SEND_RANGE = 'whatsappNotSent-1',
  WHATSAPP_NOT_SEND_CAMPAIGNS = 'whatsappNotSent-2',
  WHATSAPP_NOT_READ_RANGE = 'whatsappNotRead-1',
  WHATSAPP_NOT_READ_CAMPAIGNS = 'whatsappNotRead-2',
  WHATSAPP_SENT_RANGE = 'whatsappSent-1',
  WHATSAPP_SENT_CAMPAIGNS = 'whatsappSent-2',
}

/** 同时选中空值联系人(0-空值不在计算范围（默认值） 1-空值在计算范围) */
export enum IntExtraNullValueEnum {
  NO = 0,
  YES = 1,
}

/** 用户旅程 - 条件 */
export enum UserJourneyFilterEnum {
  JOURNEY_CLICKED = 'journey_clicked',
  JOURNEY_OPENED = 'journey_opened',

  JOURNEY_NOT_CLICKED = 'journey_not_clicked',
  JOURNEY_NOT_OPENED = 'journey_not_opened',

  /** 满意度评价 */
  CONTENT_RATING = 'content_rating',
}

/** 活动点击、打开、发送条件 - 单选 */
export enum ContactEngagementOperatorTypeEnum {
  // 选择的活动都xx过, 选择的活动都没xx过
  NONE = 'none',
  // 选择的活动至少一个xx过, 选择的活动至少一个没xx过
  LAST = 'least',
}

/** 联系人参与度 - 表单参数 */
export type CampaignScopeFormData = {
  // month：时间范围按月；day：时间范围按天；times；时间范围按次；campaign：指定某一个或者某几个活动
  type:
    | 'month'
    | 'day'
    | 'times'
    | 'campaign'
    | ContactEngagementRadioEnum
    | string;
  // 当type等于month|day|times时有效 表示具体的时间范围
  timeRange: string;
  // 当type=campaign时该字段有效，用户存放选择的活动ID
  campaignId: number[];
  campaignName: string;
  // 活动打开、点击单选条件
  operatorType?: ContactEngagementOperatorTypeEnum;
  timeRangeCampaignIds: number[];
};

/** 满意度评价 - 表单参数 */
export type ContentRatingFormData = {
  /** 默认选中Tab（活动：campaign、旅程节点：journey） */
  type?: string;
  /** 当type=campaign时该字段有效，用户存放选择的活动ID */
  campaignId: number;
  /** 活动ID&活动名称 */
  campaignName: [] | string;
  /** 当type=journey时该字段有效，用户存放选择的旅程ID */
  journeyId?: string;
};

/** 表单 - 过滤条件 */
export interface FilterFormType {
  /** 规则唯一key */
  key: string;
  /** 接口需要的 字段类型 */
  fieldType: string;
  /** 接口需要的 key */
  fieldName: string;
  /** 接口需要的 key */
  datasource: string;
  /** 大于，小于，等于 之类的 */
  operator: string;
  /** 子集 大于，小于，等于 之类的 */
  subOperator?: string;
  /** 第三个输入框的值 */
  value: any;
  /** 关于时间选择  */
  dateOption?: number;
  dateValue?: string | number;
  startTime?: any;
  endTime?: any;
  rangeValue?: any[];
  timezone?: string;
  disabled?: boolean;
  /** 分组标识 */
  group?: string;
  errorArr?: any[];
  errorMsg?: any;
  // 判断value值是否被删除
  valueDeleted?: boolean;
  valueDeletedPair?: Record<any, string>;
  /** 来源 - 扩展内容 */
  extendData?: Record<any, Record<ExtendDataKeyEnum, ExtendDataItemIF>>;
  /** 活动 - 扩展内容 */
  campaignScope?: CampaignScopeFormData;
  /** 满意度评价 - 扩展内容 */
  contentRating?: ContentRatingFormData;
  // 存储自定义字段关联项被删除时无法从分层获取条件配置中拿到被删除项信息
  ruleDetail?: string;
  /** 同时选中空值联系人(0-空值不在计算范围（默认值） 1-空值在计算范围)  */
  isIncludeNullValue?: IntExtraNullValueEnum;
  /** 控制ConditionsItem渲染项是否隐藏 */
  formItemHide?: boolean;
  /** 最大值 */
  leftValue?: string;
  /** 最小值 */
  rightValue?: string;
  /** 前端自行生成的虚拟DOM唯一key | 根据分层具体条件获取订阅统计信息 */
  uuid?: string;
  /** 测试玩家状态 - 单选按钮值 */
  testerStatusRadio?: string;
}

// 关联类型 - 枚举
export enum RelationEnum {
  ALL = 'all',
  ANY = 'any',
}

// 当开启isShowDateOption
export enum RangeDateEnum {
  /** 在过去 */
  OPTIONS1 = 1,
  /** 生命周期内 */
  OPTIONS2 = 2,
  /** 一段时间内 */
  OPTIONS3 = 3,
  /** 近7天 */
  OPTIONS4 = 4,
  /** 近15天 */
  OPTIONS5 = 5,
  /** 近30天 */
  OPTIONS6 = 6,
}

/** 提交表单 */
export type FormDataType = {
  id?: number;
  tag: string;
  // any, all
  relation: string;
  filters: FilterFormType[];
};

// 新增条件下拉 - 类型声明
export interface FilterOptionType extends SelectItemType {
  disabled: boolean;
  tips?: any;
  tooltipProps?: TooltipProps;
  fieldName: string;
  datasource: string;
  filterOption: ConditionsListIF['filterOption'];
  fieldLabel: string;
  key: string;
  group: string;
}
